/** Маскот-сом — водяной знак ANTÉ.
 *  На синих поверхностях (шапки, вход) — белый, на светлых — синий.
 *  Всегда pointer-events:none; у родителя должен быть overflow:hidden. */
type Pos = 'tr' | 'br' | 'bl' | 'center' | 'otp';

export function MascotWatermark({
  pos = 'tr',
  white = true,
  className = '',
}: {
  pos?: Pos;
  white?: boolean;
  className?: string;
}) {
  return (
    <img
      className={`mascot-wm mascot-wm--${pos} ${className}`.trim()}
      src={white ? '/ante-mascot-white.png' : '/ante-mascot-blue.png'}
      alt=""
      aria-hidden="true"
    />
  );
}

/** Маскот в пустых состояниях (empty state, ошибка) — синий, крупно, бледно. */
export function MascotEmpty() {
  return <img className="mascot" src="/ante-mascot-blue.png" alt="" aria-hidden="true" />;
}
